<nav class="navbar navbar-inverse" [class.stick]="scroll >= 400">
    <div class="container-fluid">
        <div class="navbar-header">
            <img class="site-logo white-logo" routerLink="/home" src="assets/img/rcs-white.png">
            <img class="site-logo red-logo" routerLink="/home" src="assets/img/rcs-color.png">
            <button type="button" class="navbar-toggle mobile-menu-icon hidden-md" data-toggle="collapse" data-target="#myNavbar">
               <img src="assets/icon/mobile-menu-white.svg" class="white-logo">
               <img src="assets/icon/mobile-menu.svg" class="red-logo">
              </button>
        </div>
        <div class="collapse navbar-collapse" id="myNavbar">
            <ul class="nav navbar-nav">
                <li class="active"><a routerLink="/home">Home</a></li>
                <li><a routerLink="/about-us" routerLinkActive="active">About</a></li>
                <li><a routerLink="/home" fragment="services" routerLinkActive="active" target="_self">Services</a></li>
                <li><a routerLink="/home" fragment="product" routerLinkActive="active" target="_self">Product</a></li>
                <!-- <li><a href="#">Contact</a></li> -->
            </ul>
        </div>
    </div>
</nav>